import { Button, Col, Divider, Row, Space, Switch, Typography } from 'antd'
import Messages, { shouldShow } from '../common/Messages'
import { defaultDateTime, formatDateTime } from '../../util/dateTimeUtil'
import { useCallback, useEffect, useReducer, useState } from 'react'

import Message from '../common/Message'
import MessageModal from './MessageModal'
import Section from '../common/Section'
import { Table } from 'ant-table-extensions'
import _ from 'lodash'
import axios from '../../axios/axios'
import { compareStrings } from '../../util/compareUtil'
import { getLessonDescription } from '../../util/adultLessonUtil'
import { notifyError } from '../../util/notifyUtil'
import useAdultLessonSignups from '../../hooks/api/useAdultLessonSignups'
import { useForceUpdate } from '../../hooks/useForceUpdate'
import useMessages from '../../hooks/api/useMessages'

const { Paragraph } = Typography

const colProps = {
  style: {
    padding: '1em',
  },
}

const MessagesPreview = ({ forceUpdate, showAll }) => {
  const [messages, setMessages] = useState()

  useEffect(() => {
    ;(async () => {
      const messages = await axios.get('/messages')
      setMessages(messages.data.data)
    })()
  }, [forceUpdate, showAll])

  return (
    <>
      {messages?.map((message, i) => (
        <Message
          key={i}
          message={{
            ...message.attributes,
          }}
        />
      ))}
    </>
  )
}

const MessagesPage = () => {
  const [state, setState] = useState(0)
  const { messages } = useMessages(state)
  const [message, setMessage] = useState()
  const [modalVisible, setModalVisible] = useState(false)

  const handleAdd = () => {
    setMessage(null)
    setModalVisible(true)
  }
  const handleEdit = (message) => {
    setMessage(message)
    setModalVisible(true)
  }
  const handleSave = async (message) => {
    try {
      let { id, expires } = message
      expires = new Date(expires).toISOString()
      message = { ...message, expires }
      const { data: updated } = id
        ? await axios.put('/admin/message', message)
        : await axios.post('/admin/message', message)
      const i = _.findIndex(messages, { id: updated.id })
      const newMessages = [...messages]
      if (_.isNil(i)) {
        newMessages.push(updated)
      } else {
        newMessages.splice(i, 1, updated)
      }
      setModalVisible(false)
      setState(state + 1)
    } catch (e) {
      notifyError('message-error', e)
    }
  }
  const handleCancel = () => {
    setModalVisible(false)
  }

  const columns = [
    {
      title: '',
      render: (value, record) => {
        return (
          <>
            <Button type="link" onClick={() => handleEdit(record)}>
              Edit
            </Button>
          </>
        )
      },
    },
    {
      title: 'Visible now?',
      render: (value, record) => (shouldShow(record) ? 'Yes' : 'No'),
    },
    {
      title: 'Expires',
      dataIndex: 'expires',
      render: (value, record) => formatDateTime(value, 'EEE MMM dd hh:mma'),
    },
    {
      title: 'Heading',
      dataIndex: ['heading'],
    },
    {
      title: 'Type',
      dataIndex: ['messageType'],
      render: (value, record) => {
        switch (value) {
          case 'cancelledWeather':
            return 'Rain'
          case 'cancelledOther':
            return 'Cancelled'
          case 'reminder':
            return 'Reminder'
          case 'general':
            return 'Other'

          default:
            return ''
        }
      },
    },
    {
      title: 'Enabled',
      dataIndex: ['visible'],
      render: (value, record) => (value ? 'Yes' : 'No'),
    },
  ]

  return (
    <>
      <div style={{ overflowX: 'scroll' }}>
        <MessageModal messageToEdit={message} onOk={handleSave} onCancel={handleCancel} visible={modalVisible} />
        <Section title="Messages" />
        <Paragraph>
          This page lets you configure messages that will appear at the top of the home page. Messages are only visible
          there if they're enabled and have an expiry date in the future. Messages that are currently visible appear in
          yellow in the table.
        </Paragraph>
        <Button onClick={handleAdd} type="primary">
          Add message
        </Button>
        <Table
          rowClassName={(record, index) => (shouldShow(record) ? 'messageEnabled' : 'messageDisabled')}
          className="compactTable"
          rowKey="id"
          size="small"
          columns={columns}
          dataSource={messages}
          pagination={false}
        />
      </div>

      <Section title="Message Preview" />
      <Paragraph>This is a preview of the messages, as they'd appear on the homepage when they're enabled.</Paragraph>
      <Row>
        <Col {...colProps} xs={24}>
          <Messages forceUpdate={Math.random()} showAll />
        </Col>
      </Row>
    </>
  )
}

export default MessagesPage
